import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "container"
}
const _hoisted_2 = { class: "actions" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Manage Categories / Scenarios ")
const _hoisted_4 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_ctx.user)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("h1", null, "Hi, " + _toDisplayString(_ctx.user.firstName), 1),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_router_link, {
            class: "p-button",
            to: { name: _ctx.CategoriesRoute }
          }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          }, 8, ["to"]),
          _createElementVNode("a", {
            class: "p-button",
            href: _ctx.HostGameUrl,
            target: "_blank"
          }, " Play " + _toDisplayString(_ctx.appTitle), 9, _hoisted_4)
        ])
      ]))
    : _createCommentVNode("", true)
}